<template>
  <div class="auth-page">
    <UcariHeader />
    <main class="system-page"><section class="system-card">
      <span class="system-card__icon system-card__icon--success" uk-icon="icon: check; ratio: 1.5"></span>
      <span class="eyebrow">Check your inbox</span>
      <h1>Reset link sent</h1>
      <p>We sent password reset instructions to your email. Open the link in that message to continue.</p>
      <router-link to="/login" class="uk-button uk-button-default">Return to sign in</router-link>
    </section></main>
    <RetailerFooter />
  </div>
</template>

<script>
import UcariHeader from './components/UcariHeader.vue'; 
import RetailerFooter from './components/RetailerFooter.vue'; 

export default {
  name: 'RequestPasswordReset',
  created() {
    document.title = 'Password Reset | UCARI';
  },
  components: {
    UcariHeader,  
    RetailerFooter
  }
}
</script>
